import { MenuSelect } from 'src/enum/number-enum';

type NavigationBarProps = {
  setMenuSelect: (val: MenuSelect) => void;
};

const NavigationBar = ({ setMenuSelect }: NavigationBarProps) => {
  const buttons = [
    { text: '登録', onClick: () => setMenuSelect(MenuSelect.Register), testId: 'nav-register' },
    { text: 'テナント一覧', onClick: () => setMenuSelect(MenuSelect.List), testId: 'nav-list' },
  ];
  return (
    <div className="">
      {buttons.map((button) => (
        <div
          key={button.text}
          className="cursor-pointer px-2 py-4 text-lg hover:bg-sky-200"
          onClick={button.onClick}
          data-cy={button.testId}
        >
          {button.text}
        </div>
      ))}
    </div>
  );
};

export default NavigationBar;
